import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { latestInAppUpdate } from '../content/updates';
import { isAuthed } from '../lib/api';

const APP_ROUTE = /^\/(?:dashboard|settings|admin|projects(?:\/|$))/;

export default function ProductUpdateNotice() {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const update = latestInAppUpdate;

  useEffect(() => {
    if (!update || !isAuthed() || !APP_ROUTE.test(location.pathname)) return;
    const storageKey = `piixel-update-seen:${update.slug}`;
    try {
      if (localStorage.getItem(storageKey)) return;
      // A release is announced once, even if the tab is refreshed before the
      // user dismisses it. The open card remains mounted while they navigate.
      localStorage.setItem(storageKey, new Date().toISOString());
    } catch { /* Storage can be unavailable in private browsing; still show it. */ }
    setVisible(true);
  }, [location.pathname, update]);

  useEffect(() => {
    if (!visible) return undefined;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setVisible(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [visible]);

  if (!visible || !update || !APP_ROUTE.test(location.pathname)) return null;

  return (
    <aside className="product-update-notice" aria-labelledby="product-update-title" aria-live="polite">
      <div className="product-update-notice-top">
        <span><i /> New in Piixel</span>
        <button type="button" onClick={() => setVisible(false)} aria-label="Dismiss this product update">
          <span className="material-icons" aria-hidden="true">close</span>
        </button>
      </div>
      <p className="product-update-notice-date">{update.displayDate}</p>
      <h2 id="product-update-title">{update.title}</h2>
      <p>{update.summary}</p>
      <div className="product-update-notice-highlights">
        {update.highlights.slice(0, 3).map((highlight) => <span key={highlight}><i className="material-icons" aria-hidden="true">check</i>{highlight}</span>)}
      </div>
      <Link to={`/updates/${update.slug}/`} onClick={() => setVisible(false)}>
        See what’s new <span className="material-icons" aria-hidden="true">arrow_forward</span>
      </Link>
    </aside>
  );
}
